import SiteHeader from "./components/site-header";
import HomeSlider from "./components/home-slider";
import PortalPageSlider from "./components/portal-page-slider";
import HandheldMenu from "./components/handheld-menu";
import CookiesConsent from "./components/cookies-consent";
import DropdownMenu from "./components/dropdown-menu";
import Accordion from "./components/accordion";
import Banner from "./components/banner";
import CategoriesFilter from "./components/categories-filter";
import ReadMore from "./components/read-more";
import ScrollInView from "./components/scroll-in-view";
import DeviceManager from "./utils/device-manager";
import './components/product-variations-update';
import './components/product-quantity-update';

(function ($) {
	window.$ = $;

	$(function () {
		const $html = $("html");

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass("touch");
			if (DeviceManager.isIos()) {
				$html.addClass("ios");
			}
		} else {
			$html.addClass("no-touch");
		}

		// IE detection
		if (DeviceManager.isIe11()) {
			$html.addClass("ie11");
		} else if (DeviceManager.isEdge()) {
			$html.addClass("edge");
		}

		// Handheld menu
		// const handheldMenu = new HandheldMenu();

		// General components
		const siteHeader = new SiteHeader($(".site-header"), 20);
		// const dropdownMenu = new DropdownMenu($('.header__nav'));

		// Home slider component
		const $homeSliders = $(".homepage-header__slider");
		if ($homeSliders.length) {
			$homeSliders.each(function (index, el) {
				const homeSlider = new HomeSlider($(el));
			});
		}

		// Cookie consent
		if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
			// Tarteaucitron cookie settings
			let tarteaucitronLang = "fr";

			const cookiesConsent = new CookiesConsent(tarteaucitronLang);
		}

        // Scroll in view component
        const $scrollInViewElements = $(".scroll-in-view");
        if ($scrollInViewElements.length) {
            $scrollInViewElements.imagesLoaded(function () {
                const scrollInView = new ScrollInView($scrollInViewElements);
            });
        }
	});
})(jQuery);
